import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '../modules/components/Section';
import cssUrl from '../modules/components/cssUrl';

const steps = [
  {
    num: '01',
    title: '訪問（打ち合わせ）',
    photo: '/images/flow-01.jpg',
    body: 'まずはお客様のご要望をお聞かせください。打ち合わせは無料です。お気軽に。',
  },
  {
    num: '02',
    title: '現地調査',
    photo: '/images/flow-02.jpg',
    body: '現地にて打ち合わせ・採寸など調査させていただきます。',
  },
  {
    num: '03',
    title: '設計・見積もり',
    photo: '/images/flow-03.jpg',
    body: 'ご要望をお伺いしてプランとお見積もりを作成、ご提案させていただきます。理想を一緒にカタチにしていきましょう。',
  },
  {
    num: '04',
    title: '契約',
    photo: '/images/flow-04.jpg',
    body: 'プランや予算をご確認いただき、内容が決まったらご契約させていただきます。',
  },
  {
    num: '05',
    title: '着工・近隣挨拶',
    photo: '/images/flow-05.jpg',
    body: '着工前に近隣の方へご挨拶させていただきます。より良い現場づくりを心掛けます。',
  },
  {
    num: '06',
    title: 'お引渡し',
    photo: '/images/flow-06.jpg',
    body:
      'ご希望どおりに出来ているかをご確認いただいてお引渡しになります。飯田建築との末永いお付き合いをよろしくお願いいたします。',
  },
];

/** 罫線区切りの縦リスト。ナンバー / 説明 / 写真 の3カラム（SPは写真を先頭に1カラム）。 */
function Sections() {
  return (
    <Section bg="paper" py={0} sx={{ pt: { xs: 8, sm: 12 }, pb: { xs: 10, sm: 15 } }}>
      {steps.map((step, index) => (
        <Box
          key={step.num}
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '120px 1fr 380px' },
            columnGap: { xs: 0, sm: 6 },
            rowGap: { xs: 2, sm: 0 },
            alignItems: 'start',
            py: { xs: 5, sm: 7 },
            borderTop: (theme) => `1px solid ${theme.palette.line}`,
            ...(index === steps.length - 1 && {
              borderBottom: (theme) => `1px solid ${theme.palette.line}`,
            }),
          }}
        >
          <Box
            sx={{
              fontFamily: "'Noto Serif JP', serif",
              fontSize: 15,
              letterSpacing: '.2em',
              color: 'green',
            }}
          >
            Step
            <Box component="b" sx={{ display: 'block', fontSize: 34, fontWeight: 500, lineHeight: 1.2 }}>
              {step.num}
            </Box>
          </Box>

          <Box>
            <Typography variant="h3" component="h2" sx={{ letterSpacing: '.12em', mb: 1.75 }}>
              {step.title}
            </Typography>
            <Typography sx={{ fontSize: 15, color: 'text.secondary', maxWidth: 480 }}>{step.body}</Typography>
          </Box>

          <Box
            sx={{
              aspectRatio: '3 / 2',
              backgroundImage: cssUrl(step.photo),
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              bgcolor: 'kinari',
              order: { xs: -1, sm: 0 },
            }}
          />
        </Box>
      ))}
    </Section>
  );
}

export default Sections;
